import type { SessionUser } from "../context/SessionContext.js";

export type AppShell = "portal" | "staff" | "provider";

/** Maps session user to visual shell tier (branded portal vs utilitarian staff vs provider-lite). */
export function resolveShell(user: SessionUser): AppShell {
  if (user.role === "AGENT" && !user.isStaff) return "portal";
  if (user.role === "PROVIDER" || user.role === "PPG") return "provider";
  return "staff";
}

export function shellPageClass(shell: AppShell) {
  return shell === "portal" ? "max-w-3xl" : "max-w-6xl";
}
